<template>
  <b-row style="margin-top: 2em">
    <b-col>
      <b-card bg-variant="light">
        <b-row>
          <b-col>
            <h5 class="text-info">{{ $t("globals.orders_inquiries") }}:</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="my-3">
            <b-input-group>
              <b-form-input
                v-model="filter"
                :placeholder="$t('globals.type_to_search')"
              />
              <b-input-group-append>
                <b-btn
                  variant="warning"
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  {{ $t("globals.clear") }}
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="2" class="my-3">
            <b-form-select v-model="perPage" :options="perPageOptions" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table
              hover
              small
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :current-page="currentPage"
              :per-page="perPage"
              :items="[...orders, ...inquiries]"
              :fields="fields"
              @row-clicked="rowClicked"
              @filtered="currentPage = 1"
              sort-icon-left
            >
              <template v-slot:cell(created_at)="item">
                <div v-b-tooltip.hover :title="item.item.created_at">
                  {{ item.item.created_at.substring(0, 10) }}
                </div>
              </template>
              <template v-slot:cell(number)="item">
                {{
                  item.item.order_no != null
                    ? item.item.order_no
                    : item.item.inquiry_no
                }}
              </template>
              <template v-slot:cell(type)="item">
                {{ item.item.order_no != null ? "order" : "inquiry" }}
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="[...orders, ...inquiries].length"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions,mapMutations } from "vuex";
export default {
  props: {
    customer:{
      type: Number,
      require: true
    },
    total:{
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      orders:[],
      inquiries:[],
      sortBy: "creation_date",
      sortDesc: true,
      filter: null,
      currentPage: 1,
      perPage: 20,
      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ],
      fields: [
        {
          key: "number",
          label: this.$t("globals.number"),
          sortable: true
        },
        {
          key: "type",
          label: this.$t("globals.type"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "agent.full_name",
          label: this.$t("globals.agent"),
          sortable: true
        },
        {
          key: "contract_start_on",
          label: this.$t("globals.start_date"),
          sortable: true
        },
        {
          key: "number_of_devices",
          label: this.$t("globals.number_of_devices"),
          sortable: true
        },
        {
          key: "created_at",
          label: this.$t("globals.creation_date"),
          sortable: true
        }
      ],
      items: []
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleFetch"]),
    rowClicked(item) {
      let type = item.order_no != null ? "order" : "inquiry";
      this.$router.push({ name: type, params: { id: item.id } });
    },

    fetchOrdersInquiries() {
      const data = {
        query: `
        query { 
          Customer (id:${parseInt(this.customer)}) { 
            inquiries {
              id
              inquiry_no
              created_at
              status
              agent  {
                full_name
              }
              _rowVariant
            }
            orders {
              id
              order_no
              created_at
              number_of_devices
              contract_start_on
              status
              agent  {
                full_name
              }
              _rowVariant
            }
          }
        }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.inquiries = res.Customer.inquiries;
            this.orders = res.Customer.orders;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
  },
  mounted() {
    this.fetchOrdersInquiries();
  }
};
</script>
